import type { ClientOptions } from "@redotech/rpc/client";
import { createRpcClient } from "@redotech/rpc/client";
import { rpcDefinition } from "./definition";

export function createAuthRpcClient(
  options: ClientOptions<typeof rpcDefinition>,
) {
  return createRpcClient(rpcDefinition, options);
}

export type AuthRpcClient = ReturnType<typeof createAuthRpcClient>;
